import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4","key":"svg-0"}]]

/**
 * IconBrandTelegram
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtdGVsZWdyYW0iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE1IDEwbC00IDRsNiA2bDQgLTE2bC0xOCA3bDQgMmwyIDZsMyAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-telegram
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandTelegram = createReactComponent('outline', 'brand-telegram', 'BrandTelegram', __iconNode);

export default IconBrandTelegram;